/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PersonsWithDisabilitiesModal from '../modals/PersonsWithDisabilitiesModal';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import ConfirmAlertWithAmount from 'modules/common/components/ConfirmAlertWithAmount';
import PWDContent from './PWDContent';

import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
  status: '',
  type: 'PWD',
};


function PWDContainer({
  permissions,
  history,
  match,
  isLoading,
  pwdList,
  getPwdList,
  pwdListPager,
  approveTransaction,
  rejectTransaction,
  showPwd,
}) {
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {
    getPwdList({ type: 'PWD' });
    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    type: 'PWD',
    q: formData.keyword,
    sort_by: 'asc',
    status: filter.status,
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PersonsWithDisabilitiesModal actionType="ADD" />,
      title: 'Add Citizen',
      modalSize: 'modal-lg',
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      status: e.value,
    });
    getPwdList({ ...filter, status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getPwdList({ type: 'PWD', q: formData.keyword });
    } else {
      getPwdList({ type: 'PWD' });
    }
  }, [debouncedSearchTerm]);

  // handle Approve button
  const handleApprove = (data) => (e) => {
    e.preventDefault();

    ConfirmAlertWithAmount(
      'Are you sure, you want to Approve this application?',
      (remarks, amount) => {

        const args = {
          status: 'APPROVED',
          remarks,
          amount,
          type: 'PWD',
        }
        approveTransaction(
          _.get(data, 'id'),
          args,
          () => {
            showPwd(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // handle reject button
  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        rejectTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'REJECTED'
          },
          () => {
            showPwd(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const exportCSV = () => {

    const handleExportCsv = e => {
      e.preventDefault();

      const src = `${process.env.REACT_APP_WS
        }/api/v1/administrators/export/social_amelioration_citizens?bearer_token=${token}&email=${_.get(authProfile, 'email')}&type=${param.type}&q=${param.q}&output=D`;

      setTimeout(() => {
        window.location.href = src;
      }, 500);
    }

    return (
      <div className="d-flex align-items-center px-0 pt-2">
        {Acl(permissions, ['SOCIAL AMELIORATION PWD EXPORT CSV']) && (
          <button
            onClick={handleExportCsv}
            className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary w-100"
          >
            Export PWD List to CSV
          </button>
        )}
      </div>
    )
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Applications"
            getData={getPwdList}
            setParams={param}
            setKeyword={handleOnChange}

            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'status')
            )}
            status={_.get(filter, 'status') || ''}
            keyword={_.get(formData, 'keyword') || ''}

            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            // listName="Transaction"
            label="Citizen Lists"
            // LEFT SECTION
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="senior-citizen-list">
                  {`${_.get(item, 'attributes.first_name') || ''} ${_.get(item, 'attributes.middle_name') || ''} ${_.get(item, 'attributes.last_name') || ''}`}
                </div>
                <h4 className="mt-1 mb-0 senior-citizen-list-numbers">
                  {' '}{_.get(item, 'attributes.contact_number')}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            // statusFilter
            selected={params.id}
            data={pwdList}
            dataPager={pwdListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            // RIGHT SECTION
            renderTopContent={() => (
              <div className="w-100 d-flex px-3 pb-3">
                {Acl(permissions, ['SOCIAL AMELIORATION PWD ADD']) && (
                  <button
                    type="button"
                    onClick={handleAddModal}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                    style={{ height: "32px" }}
                  >
                    <i className="fas fa-plus" /> &nbsp;&nbsp;
                    Add Person With Disabilities
                  </button>
                )}
              </div>
            )}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <PWDContent
                        testingApprove={handleApprove}
                        onApprove={handleApprove}
                        onReject={handleReject}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.pwdId && pwdList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(pwdList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            customButton={exportCSV()}
          />
        )}
      />
    </div>
  );
}

PWDContainer.propTypes = {
  permissions: PropTypes.instanceOf(Array).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,

  pwdList: PropTypes.instanceOf(Object).isRequired,
  getPwdList: PropTypes.instanceOf(Function).isRequired,
  pwdListPager: PropTypes.instanceOf(Object).isRequired,

  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,

  pwdInfo: PropTypes.instanceOf(Object).isRequired,
  showPwd: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  isLoading: api.loading.indexOf(c.GET_PWD) > -1,

  pwdList: _.get(api, `${c.GET_PWD}.list`) || [],
  pwdListPager: _.get(api, `${c.GET_PWD}.pager`) || [],

  // individual info
  pwdInfo: _.get(api, `${c.SHOW_PWD}.item`) || {},
  showPwd: PropTypes.instanceOf(Function).isRequired,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PWDContainer);